import {Grid} from '@mui/material'
import Box from '@mui/material/Box'
import React from 'react'


export default function ErrorPage() {
  return (
    <>
      <Grid container>
        <Grid item md={4}>
          <Box
            component="img"
            sx={{
              maxWidth: 1,
              px: 1,
              pt: 1
            }}
          src='/images/daisy.jpg'
          alt='Silly Dog'
          />
        
       
        </Grid>
      <h1>Oh no! Something broke.</h1>
      </Grid>
    </>
  )
}
